import {observer} from 'mobx-react';
import React from 'react';
import {action, makeObservable, observable} from 'mobx';
import store from '../../../s';
import {checkout} from '../../../../api';
import Message from '../../msg';
import ModalLineEP from '../../modals/line-ep';
import ModalLineCustom from '../../modals/line-custom';
import ModalLineGradYear from '../../modals/line-grad-year';
import ModalSimple from '../../../../global/modal-simple';
import {currency, isNullOrWhiteSpace, Portal} from '../../../../util';

declare var dataLayer: any[];
declare var modalOpen: any;
declare const collapse: {
    init: () => void;
};

interface Props {
    id: number;
}

@observer
class CartItemsMobile extends React.Component<Props> {
    @observable lastEditedId: number;
    @observable modalImageURL: string;
    @observable modalTitle: string;

    constructor(props) {
        super(props);
        this.doModal = this.doModal.bind(this);
        this.changeQty = this.changeQty.bind(this);
        this.removeProduct = this.removeProduct.bind(this);
        makeObservable(this);
    }

    componentDidMount(): void {
        collapse.init();
    }

    @action
    changeQty = async (quantity: number, id: number) => {
        store.uiCheckout.isSpecialProcessing = true;
        const item = store.checkout.cart.items.filter(o => o.id === id)[0];
        const oldQty = item.qty;
        this.lastEditedId = id;
        item.qty = quantity;
        const success = await checkout('update-qty');
        if (!success) {
            item.qty = oldQty;
        }
        store.uiCheckout.isSpecialProcessing = false;
    };

    @action
    removeProduct = async (id: number) => {
        store.uiCheckout.isSpecialProcessing = true;
        let newQty = 0;
        const item = store.checkout.cart.items.filter(o => o.id === id)[0];
        const oldQty = item.qty;
        this.lastEditedId = id;
        if (newQty === -1) {
            item._showQtyInput = true;
            newQty = 10;
        }
        item.qty = newQty;
        const success = await checkout('update-qty');
        if (!success) {
            item.qty = oldQty;
        }
        store.uiCheckout.isSpecialProcessing = false;

        const dle: ga4_dle_remove_from_cart = {
            event: 'remove_from_cart',
            ecommerce: {
                currency: 'USD',
                value: store.checkout.cart.pricing.total,
                items: [
                    {
                        item_id: item.itemId.toString(),
                        item_name: item.title2,
                        item_brand: 'CHC',
                        item_category: item.gaCategory,
                        item_variant: item.gaVariant,
                        coupon: item.gaDiscountCode,
                        index: item.gaPosition,
                        item_list_name: item.gaList,
                        quantity: item.qty,
                        currency: 'USD',
                        price: item.price,
                        location_id: 'ChIJUcHLaPbi54kRtbVMrbSH4MU',
                    },
                ],
            },
        };
        dataLayer.push(dle);

        // ga ua
        dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
                currencyCode: 'USD',
                add: {
                    // 'add' actionFieldObject measures.
                    products: [
                        {
                            //  adding a product to a shopping cart.
                            name: item.title2,
                            id: item.productId,
                            price: item.price,
                            brand: 'CHC',
                            category: item.gaCategory,
                            variant: item.gaVariant,
                            quantity: item.qty,
                        },
                    ],
                },
            },
        });
    };

    @action
    doModal(o: ICartLineItem) {
        this.modalImageURL = o.imgFull;
        this.modalTitle = `${o.title1} ${o.title2}`;
        modalOpen(`modal-cart-image-${this.props.id.toString()}`);
    }

    render() {
        collapse.init();

        return (
            <div>
                {store.checkout.cart.items.map((o, _p) => (
                    <div key={o.id}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'start',
                                gap: 10,
                            }}
                        >
                            <img
                                src={o.imgThumb.replace('_200_200.png', '_400_400.png').replace('com//', 'com/')}
                                style={{width: '30%'}}
                                alt={`${o.title1} ${o.title2}`}
                                className="resp pointer"
                                loading="lazy"
                                onClick={() => this.doModal(o)}
                                role="button"
                                aria-label="Show product photo"
                                tabIndex={0}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        this.doModal(o);
                                    }
                                }}
                            />
                            <div>
                                <div
                                    className="title1"
                                    style={{lineHeight: '1.25rem', fontWeight: 600}}
                                >
                                    <a
                                        href={o.URL}
                                        aria-label={`View Cart Product ${o.title1} ${o.title2}`}
                                        style={{color: 'black'}}
                                    >
                                        {o.title1} {o.title2}
                                    </a>
                                </div>
                                {o.productId !== 24791 && (
                                    <div
                                        id={`details-${this.props.id.toString()}-cs-${o.id.toString()}`}
                                        style={{padding: 0}}
                                    >
                                        <div className="details">
                                            {o.details.map((d, i) => (
                                                <div
                                                    key={i}
                                                    dangerouslySetInnerHTML={{__html: d}}
                                                    style={{fontSize: 12}}
                                                />
                                            ))}
                                            {o.hasEp && (
                                                <div>
                                                    <div style={{fontSize: 12}}>
                                                        <span className="details-title">{o.epTitle}</span>

                                                        <span
                                                            style={{
                                                                paddingLeft: 4,
                                                                fontSize: 12,
                                                            }}
                                                            className="link"
                                                            onClick={() => modalOpen(`modal-l-ep-cs-${o.id}`)}
                                                        >
                                                            <i className="fas fa-edit link pointer"></i>
                                                        </span>
                                                    </div>
                                                    <div style={{paddingLeft: 6}}>
                                                        {o.ep1 && <div>{o.ep1}</div>}
                                                        {o.ep2 && <div>{o.ep2}</div>}
                                                        {o.ep3 && <div>{o.ep3}</div>}
                                                        {o.ep4 && <div>{o.ep4}</div>}
                                                        {o.ep5 && <div>{o.ep5}</div>}
                                                        {o.ep6 && <div>{o.ep6}</div>}
                                                        {o.ep7 && <div>{o.ep7}</div>}
                                                        {o.ep8 && <div>{o.ep8}</div>}
                                                        {o.ep9 && <div>{o.ep9}</div>}
                                                        {o.ep10 && <div>{o.ep10}</div>}
                                                    </div>
                                                    <ModalLineEP
                                                        id={o.id}
                                                        modalId={`modal-l-ep-cs-${o.id}`}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        {o.hasCustom && (
                                            <div>
                                                <div>
                                                    {o.CustomField1_Title.length > 0 && o.CustomField1_Title.trim().length > 0 && (
                                                        <div style={{fontSize: 12}}>
                                                            <span
                                                                className="details-title"
                                                                style={{
                                                                    color: '#616161',
                                                                }}
                                                            >
                                                                {o.CustomField1_Title}:
                                                            </span>{' '}
                                                            {o.CustomField1}
                                                            <span
                                                                style={{
                                                                    paddingLeft: 4,
                                                                    fontSize: 12,
                                                                }}
                                                                className="link"
                                                                onClick={() => modalOpen(`modal-line-custom-${o.id}`)}
                                                            >
                                                                <i className="fas fa-edit link pointer"></i>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {o.CustomField2_Title.length > 0 && o.CustomField2_Title.trim().length > 0 && (
                                                        <div style={{fontSize: 12}}>
                                                            <span
                                                                className="details-title"
                                                                style={{
                                                                    color: '#616161',
                                                                }}
                                                            >
                                                                {o.CustomField2_Title}:
                                                            </span>{' '}
                                                            {o.CustomField2}
                                                            <span
                                                                style={{
                                                                    paddingLeft: 4,
                                                                    fontSize: 12,
                                                                }}
                                                                className="link"
                                                                onClick={() => modalOpen(`modal-line-custom-${o.id}`)}
                                                            >
                                                                <i className="fas fa-edit link pointer"></i>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {o.CustomField3_Title.length > 0 && o.CustomField3_Title.trim().length > 1 && (
                                                        <div style={{fontSize: 12}}>
                                                            <span
                                                                className="details-title"
                                                                style={{
                                                                    color: '#616161',
                                                                }}
                                                            >
                                                                {o.CustomField3_Title}:
                                                            </span>{' '}
                                                            {o.CustomField3}
                                                            <span
                                                                style={{
                                                                    paddingLeft: 4,
                                                                    fontSize: 12,
                                                                }}
                                                                className="link"
                                                                onClick={() => modalOpen(`modal-line-custom-${o.id}`)}
                                                            >
                                                                <i className="fas fa-edit link pointer"></i>
                                                            </span>
                                                        </div>
                                                    )}
                                                    <ModalLineCustom
                                                        id={o.id}
                                                        modalId={`modal-line-custom-${o.id}`}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {!o.IsDYF && o.gradYear > 0 && (
                                            <div>
                                                <div style={{fontSize: 12}}>
                                                    <span
                                                        className="details-title"
                                                        style={{
                                                            color: '#616161',
                                                        }}
                                                    >
                                                        Grad Year:
                                                    </span>{' '}
                                                    {o.gradYear.toString()}
                                                    <span
                                                        role="button"
                                                        style={{
                                                            paddingLeft: 4,
                                                            fontSize: 12,
                                                        }}
                                                        className="link"
                                                        onClick={() => modalOpen(`modal-line-grad-year-${o.id}`)}
                                                        aria-label="Edit graduation year"
                                                        aria-haspopup="dialog"
                                                    >
                                                        <i
                                                            className="fas fa-edit link pointer"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </span>
                                                </div>
                                                <ModalLineGradYear
                                                    id={o.id}
                                                    modalId={`modal-line-grad-year-${o.id}`}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="cart-price-container">
                                    <span className="price-disc">{currency(o.price)}</span>
                                    {/*{195 > 0 && (*/}
                                    {/*    <div className="d-flex align-items-center">*/}
                                    {/*        <span className="price-orig">{util.currency(195)}</span>*/}
                                    {/*        <span className="price-off">{`${(((o.price - 195) / o.price) * 100).toFixed()}% OFF`}</span>*/}
                                    {/*    </div>*/}
                                    {/*)}*/}
                                </div>
                                {!isNullOrWhiteSpace(o.special_msg) && <div className="discount-highlight">{o.special_msg}</div>}
                                {o.productId !== 24791 && (
                                    <div className="quantity-container">
                                        {!o._showQtyInput && (
                                            <div className="quantity">
                                                <span
                                                    role="button"
                                                    onClick={() => o.qty > 0 && this.changeQty(o.qty - 1, o.id)}
                                                >
                                                    -
                                                </span>
                                                <span>{o.qty}</span>
                                                <span
                                                    role="button"
                                                    onClick={() => o.qty <= 20 && this.changeQty(o.qty + 1, o.id)}
                                                >
                                                    +
                                                </span>
                                            </div>
                                        )}
                                        <button
                                            className="remove text-btn"
                                            onClick={() => this.removeProduct(o.id)}
                                            type="button"
                                            aria-label="Remove product"
                                        >
                                            Remove
                                        </button>
                                        {this.lastEditedId === o.id && (
                                            <div>
                                                <Message msgType={ICheckoutMessageType.cart_qty} />
                                            </div>
                                        )}
                                    </div>
                                )}
                                {!store.checkout.isMyFrames && o.is_fast_shipping && o.productId !== 24715 && o.productId !== 24716 && o.productId !== 24717 && o.productId !== 67336 && o.productId !== 67337 && (
                                    <div
                                        className={`fast-shipping-mobile fast-shipping-${Portal?.PortalID}`}
                                        style={{marginTop: 15, border: 'none'}}
                                    >
                                        <i
                                            className={Portal?.PortalID !== 3 ? `fas fa-shipping-fast` : `fas fa-cart-shopping-fast`}
                                            style={{marginRight: 10}}
                                            aria-hidden={true}
                                        />
                                        <span>SHIPS IN 2-3 DAYS</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        {o.messages
                            .filter(y => y.msgType === ICheckoutMessageType.backorder)
                            .map(x => (
                                <div
                                    className="alert alert-info"
                                    style={{margin: '2% 5%'}}
                                >
                                    {x.msg}
                                </div>
                            ))}
                        <div className="hr"></div>
                    </div>
                ))}

                <ModalSimple
                    id={`modal-cart-image-${this.props.id.toString()}`}
                    title={`${this.modalTitle}`}
                >
                    <div>
                        <img
                            src={this.modalImageURL}
                            alt={`${this.modalTitle}`}
                            className="resp"
                        />
                    </div>
                </ModalSimple>
            </div>
        );
    }
}

export default CartItemsMobile;
